import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import Warehouse from 'containers/Warehouses/WarehouseComponent'
import useWarehousesLoading from 'hooks/useWarehousesLoading'
import KeyCabinetBadge from 'containers/KeyCabinet/Badge'
import { useHistory, useParams } from 'react-router-dom'
import MagActions from 'containers/Warehouse/MagActions'
import MagHistory from 'containers/Warehouse/MagHistory'
import MagAccess from 'containers/Warehouse/MagAccess'
import MagManage from 'containers/Warehouse/MagManage'
import MagStatus from 'containers/Warehouse/MagStatus'
import { SECTION_TYPES } from 'containers/Warehouse'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import MagNumber from 'components/MagNumber'
import { useReduxSelector } from 'store'
import Player from 'components/Player'
import { useState } from 'react'
import './style.scss'

const type = process.env.REACT_APP_TYPE

const DesktopWarehouse = () => {
  const { id } = useParams()
  const [isPreview, showPreview] = useState(false)
  const warehouse = useReduxSelector(state => selectWarehouse(state, id))
  const { number, contractId, placeAddress, typeName, isShared, acronym, sharing, events, permissions, warehouseCamera, rentableType, hasAccess, actions } = warehouse
  const hasBadge = hasAccess && actions?.key_cabinet?.grant?.canOpen

  useWarehousesLoading(!contractId)

  const { push, goBack } = useHistory()
  const { t } = useTranslation('warehouse')
  const goTo = (path) => {
    push(`/warehouses/${id}/${path}`)
  }

  return (
    <div className='desktopWarehouse'>
      {hasBadge && <KeyCabinetBadge
        id={id}
        fromWarehouse
        purpose={actions?.key_cabinet?.grant?.purpose}
      />}
      <div className='title --withBtn'>
        <div>{typeName}</div>
        <div className='group'>
          <span>{placeAddress}</span>
        </div>
        <ArrowBtn
          text={t('back')}
          className='--reverse --black'
          action={goBack}
        />
      </div>
      <div className="desktopWarehouse__wrap">
        <div className="desktopWarehouse__sidebar">
          {warehouseCamera && type === 'mm' && <div
            className='warehouse__previewBtn'
            onClick={() => {
              showPreview(prev => !prev)
            }}>
            <i className='icon icon--monitoring s32' />
          </div>}
          <MagNumber
            isDesktop
            number={number}
            acronym={acronym}
            isShared={isShared}
            rentableType={rentableType}
          />
          {isPreview && warehouseCamera
            ? <Player
              camera={warehouseCamera?.hqCam || warehouseCamera?.defaultCam}
            />
            : <Warehouse
              {...warehouse}
            />}
          <MagStatus isDesktop />
          <MagActions
            id={id}
            expanded={true}
            toggleMenu={false}
            navigate={push} />
        </div>
        <div className="desktopWarehouse__content">
          <MagManage
            id={id}
            isDesktop
            navigate={push}
          />
          {(Array.isArray(events) && events.length > 0 && (!isShared || permissions?.includes('events'))) && <MagHistory
            id={id}
            more={() => {
              goTo(SECTION_TYPES.history)
            }}
          />}
          {Array.isArray(sharing) && sharing.length > 0 && (!isShared || permissions?.includes('share')) && <MagAccess
            more={() => {
              goTo(SECTION_TYPES.access)
            }}
          />}
        </div>
      </div>
    </div>
  )
}

export default DesktopWarehouse